import { Button, Dialog } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useState } from "react";
import Breadcrumb from "../../Components/Navigation/Breadcrumbs/Breadcrumbs";
import SortableTable from "../../Components/Table/SortableTable";
import ClientTableCell from "../../Components/Table/ClientTableCell";
import CreateClientModal from "../../Components/Modal/CreateClientModal";
import Signifier from "../../Components/Signifier";
import { useAllClientsQuery } from "../../Queries/ClientManagementQueries";

const useStyles = makeStyles((theme) => ({
  button: {
    background: theme.palette.primary.main,
    marginTop: "20px",
    width: "98%",
  },
  createButton: {
    background: theme.palette.primary.main,
    color: "white",
    position: "absolute",
    right: "0px",
    marginRight: "3%",
    width: "15%",
    marginTop: "85px",
    "&:hover": {
      background: theme.palette.primary.main,
      color: "white",
    },
    [theme.breakpoints.down("sm")]: {
      position: "relative",
      width: "98%",
      marginTop: "25px",
    },
  },
}));

const columns = [
  { label: "Name", propName: "name" },
  { label: "Shortname", propName: "shortName" },
  { label: "Hostname", propName: "hostname" },
  { label: "Date Created", propName: "dateCreated" },
];

export default function ClientManagementPage() {
  const classes = useStyles();
  const { data, isLoading } = useAllClientsQuery();
  const [openModal, setOpenModal] = useState(false);

  const [showSignifier, setShowSignifier] = useState(false);
  const [showError, setShowError] = useState(false);
  const [createProcessing, setCreateProcessing] = useState(false);

  return (
    <>
      <Signifier
        showSignifier={showSignifier}
        setShowSignifier={setShowSignifier}
        message="Client Created"
        error={showError}
        errorMessage={undefined}
      />
      <div className="page-container">
        <Breadcrumb />
        <h1 className="page-title">Careers Clients</h1>
        <SortableTable
          columns={columns}
          tableData={data}
          rowComponent={ClientTableCell}
          loading={isLoading}
          defaultSortIndex={0}
          hideSearch={undefined}
          setTableData={undefined}
          reverse={undefined}
          pagination={undefined}
          totalItemCount={undefined}
        />
        <Button
          className={classes.createButton}
          type="submit"
          variant="contained"
          color="primary"
          data-test="create-careers-client-button"
          onClick={() => setOpenModal(true)}
        >
          Create Client
        </Button>
      </div>
      <Dialog
        maxWidth="md"
        open={openModal}
        onClose={(event, reason) => {
          if (!createProcessing && reason === "backdropClick") {
            setOpenModal(false);
          }
        }}
      >
        <CreateClientModal
          openModal={setOpenModal}
          setShowSignifier={setShowSignifier}
          setShowError={setShowError}
          createProcessing={createProcessing}
          setCreateProcessing={setCreateProcessing}
        />
      </Dialog>
    </>
  );
}
